<template>
  <BaseDialog isOpen>
    <template v-slot:title>
      Are you sure you want to confirm the offer?
    </template>
    <template v-slot:actions>
      <div>
        <PrimaryButton @click.native="cancel" text>
          Cancel
        </PrimaryButton>
        <PrimaryButton @click.native="handleSubmit" :loading="isLoading">
          Confirm Offer
        </PrimaryButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { OFFERS_NAMESPACE } from "@/store/modules/offers";
import { COMPLETE_OFFER } from "@/store/modules/offers/actions";

const { mapActions } = createNamespacedHelpers(OFFERS_NAMESPACE);

export default {
  name: "CompleteOfferDialog",
  components: { PrimaryButton, BaseDialog },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    currentOfferId() {
      return this.$route.params.id;
    }
  },
  methods: {
    ...mapActions({
      completeOffer: COMPLETE_OFFER
    }),
    async handleSubmit() {
      this.isLoading = true;
      await this.completeOffer(this.currentOfferId);
      this.cancel();
      this.isLoading = false;
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
